var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 63,
    viewBox: "0 0 66 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6383 60.9839H43.3402V62.3015H44.6383V60.9839Z",
    fill: "#25231F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3402 60.9839H42.0421V62.3015H43.3402V60.9839Z",
    fill: "#25231F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0421 60.9839H40.744V62.3015H42.0421V60.9839Z",
    fill: "#25231F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.744 60.9839H39.4459V62.3015H40.744V60.9839Z",
    fill: "#25231F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4458 60.9839H38.1477V62.3015H39.4458V60.9839Z",
    fill: "#25231F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 60.9839H36.8378V62.3015H38.1359V60.9839Z",
    fill: "#25231F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 60.9839H35.5397V62.3015H36.8378V60.9839Z",
    fill: "#25231F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5397 60.9839H34.2416V62.3015H35.5397V60.9839Z",
    fill: "#25231F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2416 60.9839H32.9435V62.3015H34.2416V60.9839Z",
    fill: "#25231F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9435 60.9839H31.6454V62.3015H32.9435V60.9839Z",
    fill: "#25231F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6454 60.9839H30.3473V62.3015H31.6454V60.9839Z",
    fill: "#25231F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3473 60.9839H29.0492V62.3015H30.3473V60.9839Z",
    fill: "#25231F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0374 60.9839H27.7393V62.3015H29.0374V60.9839Z",
    fill: "#25231F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6383 59.6665H43.3402V60.9841H44.6383V59.6665Z",
    fill: "#25231F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3402 59.6665H42.0421V60.9841H43.3402V59.6665Z",
    fill: "#F3A102"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3402 58.3486H42.0421V59.6663H43.3402V58.3486Z",
    fill: "#25231F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0421 58.3486H40.744V59.6663H42.0421V58.3486Z",
    fill: "#F3A102"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.744 58.3486H39.4459V59.6663H40.744V58.3486Z",
    fill: "#F3A102"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0421 57.0317H40.744V58.3494H42.0421V57.0317Z",
    fill: "#25231F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.744 57.0317H39.4459V58.3494H40.744V57.0317Z",
    fill: "#F3A102"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4458 57.0317H38.1477V58.3494H39.4458V57.0317Z",
    fill: "#F3A102"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 57.0317H36.8378V58.3494H38.1359V57.0317Z",
    fill: "#F3A102"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.744 57.0305V55.7604V55.7129H40.0477H39.4459V57.0305H40.744Z",
    fill: "#25231F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4458 55.7129H38.1477V57.0305H39.4458V55.7129Z",
    fill: "#25231F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 55.7129H36.8378V57.0305H38.1359V55.7129Z",
    fill: "#25231F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 55.7129H35.5397V57.0305H36.8378V55.7129Z",
    fill: "#F3A102"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 54.396H36.8378V55.7136H38.1359V54.396Z",
    fill: "#25231F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 54.396H35.5397V55.7136H36.8378V54.396Z",
    fill: "#F3A102"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 53.0669H36.8378V54.3845H38.1359V53.0669Z",
    fill: "#25231F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 53.0669H35.5397V54.3845H36.8378V53.0669Z",
    fill: "#F3A102"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 51.7485H36.8378V53.0662H38.1359V51.7485Z",
    fill: "#25231F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 51.7485H35.5397V53.0662H36.8378V51.7485Z",
    fill: "#F3A102"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 50.4307H36.8378V51.7483H38.1359V50.4307Z",
    fill: "#25231F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 50.4307H35.5397V51.7483H36.8378V50.4307Z",
    fill: "#F3A102"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 49.1138H36.8378V50.4314H38.1359V49.1138Z",
    fill: "#25231F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 49.1138H35.5397V50.4314H36.8378V49.1138Z",
    fill: "#F3A102"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 47.7949H36.8378V49.1126H38.1359V47.7949Z",
    fill: "#25231F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 47.7949H35.5397V49.1126H36.8378V47.7949Z",
    fill: "#F3A102"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 46.479H36.8378V47.7966H38.1359V46.479Z",
    fill: "#25231F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 46.479H35.5397V47.7966H36.8378V46.479Z",
    fill: "#F3A102"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 45.1606H36.8378V46.4783H38.1359V45.1606Z",
    fill: "#25231F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 45.1606H35.5397V46.4783H36.8378V45.1606Z",
    fill: "#F3A102"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 43.8418H36.8378V45.1594H38.1359V43.8418Z",
    fill: "#25231F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 43.8418H35.5397V45.1594H36.8378V43.8418Z",
    fill: "#F3A102"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 42.5137H36.8378V43.8313H38.1359V42.5137Z",
    fill: "#25231F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 42.5137H35.5397V43.8313H36.8378V42.5137Z",
    fill: "#F3A102"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 41.1953H36.8378V42.5129H38.1359V41.1953Z",
    fill: "#25231F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 41.1953H35.5397V42.5129H36.8378V41.1953Z",
    fill: "#F3A102"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 39.8779H36.8378V41.1956H38.1359V39.8779Z",
    fill: "#25231F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 39.8779H35.5397V41.1956H36.8378V39.8779Z",
    fill: "#F3A102"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 38.5601H36.8378V39.8777H38.1359V38.5601Z",
    fill: "#25231F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 38.5601H35.5397V39.8777H36.8378V38.5601Z",
    fill: "#F3A102"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5397 38.5601H34.2416V39.8777H35.5397V38.5601Z",
    fill: "#F3A102"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0421 37.2432H40.744V38.5608H42.0421V37.2432Z",
    fill: "#F3A102"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M40.744 37.2432H39.4459V38.5608H40.744V37.2432Z",
    fill: "#F3A102"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4458 37.2432H38.1477V38.5608H39.4458V37.2432Z",
    fill: "#F3A102"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 37.2432H36.8378V38.5608H38.1359V37.2432Z",
    fill: "#F3A102"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3402 35.9253H42.0421V37.2429H43.3402V35.9253Z",
    fill: "#F3A102"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0421 35.9253H40.744V37.2429H42.0421V35.9253Z",
    fill: "#F3A102"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40.744 35.9253H39.4459V37.2429H40.744V35.9253Z",
    fill: "#F3A102"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9364 34.6084H44.6383V35.926H45.9364V34.6084Z",
    fill: "#F3A102"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6383 34.6084H43.3402V35.926H44.6383V34.6084Z",
    fill: "#F3A102"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3402 34.6084H42.0421V35.926H43.3402V34.6084Z",
    fill: "#F3A102"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0421 34.6084H40.744V35.926H42.0421V34.6084Z",
    fill: "#F3A102"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8449 34.6084H22.5468V35.926H23.8449V34.6084Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2369 34.6084H19.9388V35.926H21.2369V34.6084Z",
    fill: "#FCD046"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2463 33.2769H45.9482V34.5945H47.2463V33.2769Z",
    fill: "#F3A102"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9364 33.2769H44.6383V34.5945H45.9364V33.2769Z",
    fill: "#F3A102"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6383 33.2769H43.3402V34.5945H44.6383V33.2769Z",
    fill: "#F3A102"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5468 33.2769H21.2487V34.5945H22.5468V33.2769Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5444 31.9609H47.2463V33.2786H48.5444V31.9609Z",
    fill: "#F3A102"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2463 31.9609H45.9482V33.2786H47.2463V31.9609Z",
    fill: "#F3A102"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9364 31.9609H44.6383V33.2786H45.9364V31.9609Z",
    fill: "#F3A102"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2369 31.9609H19.9388V33.2786H21.2369V31.9609Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 30.6421H48.5445V31.9597H49.8426V30.6421Z",
    fill: "#F3A102"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5444 30.6421H47.2463V31.9597H48.5444V30.6421Z",
    fill: "#F3A102"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2463 30.6421H45.9482V31.9597H47.2463V30.6421Z",
    fill: "#F3A102"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9388 30.6421H18.6407V31.9597H19.9388V30.6421Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 29.3267H49.8425V30.6443H51.1406V29.3267Z",
    fill: "#F3A102"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 29.3267H48.5445V30.6443H49.8426V29.3267Z",
    fill: "#F3A102"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5444 29.3267H47.2463V30.6443H48.5444V29.3267Z",
    fill: "#F3A102"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6407 29.3267H17.3426V30.6443H18.6407V29.3267Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7369 28.0068H52.4388V29.3245H53.7369V28.0068Z",
    fill: "#F3A102"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4388 28.0068H51.1407V29.3245H52.4388V28.0068Z",
    fill: "#F3A102"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 28.0068H49.8425V29.3245H51.1406V28.0068Z",
    fill: "#F3A102"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 28.0068H48.5445V29.3245H49.8426V28.0068Z",
    fill: "#F3A102"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 28.0068H16.0445V29.3245H17.3426V28.0068Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9411 26.6899H57.643V28.0076H58.9411V26.6899Z",
    fill: "#FCD046"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3449 26.6899H55.0468V28.0076H56.3449V26.6899Z",
    fill: "#F3A102"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0468 26.6899H53.7487V28.0076H55.0468V26.6899Z",
    fill: "#F3A102"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 26.6899H49.8425V28.0076H51.1406V26.6899Z",
    fill: "#F3A102"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 26.6899H48.5445V28.0076H49.8426V26.6899Z",
    fill: "#F3A102"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 26.6899H16.0445V28.0076H17.3426V26.6899Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6431 25.3721H56.3449V26.6897H57.6431V25.3721Z",
    fill: "#F3A102"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 25.3721H49.8425V26.6897H51.1406V25.3721Z",
    fill: "#F3A102"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 25.3721H48.5445V26.6897H49.8426V25.3721Z",
    fill: "#F3A102"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 25.3721H16.0445V26.6897H17.3426V25.3721Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8402 25.3721H9.54208V26.6897H10.8402V25.3721Z",
    fill: "#24231F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9411 24.0425H57.643V25.3601H58.9411V24.0425Z",
    fill: "#F3A102"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 24.0425H49.8425V25.3601H51.1406V24.0425Z",
    fill: "#F3A102"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 24.0425H48.5445V25.3601H49.8426V24.0425Z",
    fill: "#F3A102"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 24.0425H16.0445V25.3601H17.3426V24.0425Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9411 22.7256H57.643V24.0432H58.9411V22.7256Z",
    fill: "#F3A102"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 22.7256H49.8425V24.0432H51.1406V22.7256Z",
    fill: "#F3A102"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 22.7256H48.5445V24.0432H49.8426V22.7256Z",
    fill: "#F3A102"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 22.7256H16.0445V24.0432H17.3426V22.7256Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2392 21.4062H58.9411V22.7239H60.2392V21.4062Z",
    fill: "#F3A102"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 21.4062H49.8425V22.7239H51.1406V21.4062Z",
    fill: "#F3A102"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 21.4062H48.5445V22.7239H49.8426V21.4062Z",
    fill: "#F3A102"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 21.4062H16.0445V22.7239H17.3426V21.4062Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5374 20.0898H60.2393V21.4075H61.5374V20.0898Z",
    fill: "#F3A102"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 20.0898H49.8425V21.4075H51.1406V20.0898Z",
    fill: "#F3A102"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 20.0898H48.5445V21.4075H49.8426V20.0898Z",
    fill: "#F3A102"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 20.0898H16.0445V21.4075H17.3426V20.0898Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5374 18.7725H60.2393V20.0901H61.5374V18.7725Z",
    fill: "#F3A102"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 18.7725H49.8425V20.0901H51.1406V18.7725Z",
    fill: "#F3A102"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 18.7725H48.5445V20.0901H49.8426V18.7725Z",
    fill: "#F3A102"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 18.7725H16.0445V20.0901H17.3426V18.7725Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2393 17.4541V18.7717H61.5374V17.4541H60.2393Z",
    fill: "#F3A102"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 17.4541H49.8425V18.7717H51.1406V17.4541Z",
    fill: "#F3A102"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 17.4541H48.5445V18.7717H49.8426V17.4541Z",
    fill: "#F3A102"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 17.4541H16.0445V18.7717H17.3426V17.4541Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 16.1367H61.5374V17.4543H62.8355V16.1367Z",
    fill: "#F3A102"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 16.1367H49.8425V17.4543H51.1406V16.1367Z",
    fill: "#F3A102"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 16.1367H48.5445V17.4543H49.8426V16.1367Z",
    fill: "#F3A102"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 16.1367H16.0445V17.4543H17.3426V16.1367Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 14.8081H61.5374V16.1257H62.8355V14.8081Z",
    fill: "#F3A102"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 14.8081H49.8425V16.1257H51.1406V14.8081Z",
    fill: "#F3A102"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 14.8081H48.5445V16.1257H49.8426V14.8081Z",
    fill: "#F3A102"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 14.8081H16.0445V16.1257H17.3426V14.8081Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 13.4893H61.5374V14.8069H62.8355V13.4893Z",
    fill: "#F3A102"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 13.4893H49.8425V14.8069H51.1406V13.4893Z",
    fill: "#F3A102"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 13.4893H48.5445V14.8069H49.8426V13.4893Z",
    fill: "#F3A102"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 13.4893H16.0445V14.8069H17.3426V13.4893Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 12.1724H61.5374V13.49H62.8355V12.1724Z",
    fill: "#F3A102"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 12.1724H49.8425V13.49H51.1406V12.1724Z",
    fill: "#F3A102"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 12.1724H48.5445V13.49H49.8426V12.1724Z",
    fill: "#F3A102"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 12.1724H16.0445V13.49H17.3426V12.1724Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63597 12.1724H4.33786V13.49H5.63597V12.1724Z",
    fill: "#262626"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 10.854H61.5374V12.1716H62.8355V10.854Z",
    fill: "#F3A102"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 10.854H49.8425V12.1716H51.1406V10.854Z",
    fill: "#F3A102"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 10.854H48.5445V12.1716H49.8426V10.854Z",
    fill: "#F3A102"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 10.854H16.0445V12.1716H17.3426V10.854Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 9.53662H61.5374V10.8543H62.8355V9.53662Z",
    fill: "#F3A102"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 9.53662H49.8425V10.8543H51.1406V9.53662Z",
    fill: "#F3A102"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 9.53662H48.5445V10.8543H49.8426V9.53662Z",
    fill: "#F3A102"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 9.53662H16.0445V10.8543H17.3426V9.53662Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 8.21924H61.5374V9.53687H62.8355V8.21924Z",
    fill: "#F3A102"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 8.21924H49.8425V9.53687H51.1406V8.21924Z",
    fill: "#F3A102"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 8.21924H48.5445V9.53687H49.8426V8.21924Z",
    fill: "#F3A102"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 8.21924H16.0445V9.53687H17.3426V8.21924Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 6.90186H61.5374V8.21949H62.8355V6.90186Z",
    fill: "#F3A102"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 6.90186H49.8425V8.21949H51.1406V6.90186Z",
    fill: "#F3A102"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 6.90186H48.5445V8.21949H49.8426V6.90186Z",
    fill: "#F3A102"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 6.90186H16.0445V8.21949H17.3426V6.90186Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 5.5835H61.5374V6.90113H62.8355V5.5835Z",
    fill: "#F3A102"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 5.5835H49.8425V6.90113H51.1406V5.5835Z",
    fill: "#F3A102"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 5.5835H48.5445V6.90113H49.8426V5.5835Z",
    fill: "#F3A102"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 5.5835H16.0445V6.90113H17.3426V5.5835Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5374 4.25439H60.2393V5.57202H61.5374V4.25439Z",
    fill: "#F3A102"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2392 4.25439H58.9411V5.57202H60.2392V4.25439Z",
    fill: "#F3A102"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9411 4.25439H57.643V5.57202H58.9411V4.25439Z",
    fill: "#F3A102"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6431 4.25439H56.3449V5.57202H57.6431V4.25439Z",
    fill: "#F3A102"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3449 4.25439H55.0468V5.57202H56.3449V4.25439Z",
    fill: "#F3A102"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0468 4.25439H53.7487V5.57202H55.0468V4.25439Z",
    fill: "#F3A102"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7369 4.25439H52.4388V5.57202H53.7369V4.25439Z",
    fill: "#F3A102"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4388 4.25439H51.1407V5.57202H52.4388V4.25439Z",
    fill: "#F3A102"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 4.25439H49.8425V5.57202H51.1406V4.25439Z",
    fill: "#F3A102"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 4.25439H48.5445V5.57202H49.8426V4.25439Z",
    fill: "#F3A102"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 4.25439H16.0445V5.57202H17.3426V4.25439Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4388 2.93701H51.1407V4.25464H52.4388V2.93701Z",
    fill: "#F3A102"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 2.93701H49.8425V4.25464H51.1406V2.93701Z",
    fill: "#F3A102"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3426 2.93701H16.0445V4.25464H17.3426V2.93701Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4388 1.61914H51.1407V2.93677H52.4388V1.61914Z",
    fill: "#F3A102"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5468 34.6084H21.2487V35.926H22.5468V34.6084Z",
    fill: "#FECE00"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0468 28.0068H53.7487V29.3245H52.4388H51.1407V30.6421H52.4388H53.7487H55.0468V29.3245H56.3449V28.0068H55.0468Z",
    fill: "#FECE00"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6431 26.6899H56.3449V28.0076H57.6431V26.6899Z",
    fill: "#FECE00"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5374 2.93701H60.2393H58.9412H57.6431H56.3449H55.0468H53.7487H52.4388V4.25463H53.7487H55.0468H56.3449H57.6431H58.9412H60.2393H61.5374V5.58412H62.8473V6.90174V8.21936V9.53698V10.8546V12.1722V13.4898V14.8075V16.1369V17.4546H61.5374V18.7722V20.0898V21.4074H60.2393V22.725H58.9412V24.0427V25.3722H57.6431V26.6898H58.9412H60.2393V25.3722V24.0427H61.5374V22.725H62.8473V21.4074V20.0898V18.7722H64.1454V17.4546V16.1369V14.8075V13.4898V12.1722V10.8546V9.53698V8.21936V6.90174V5.58412V4.25463V2.93701H62.8473H61.5374Z",
    fill: "#FECE00"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74167 5.58387V6.90149V8.21911V9.53673V10.8543V12.172V13.4896V14.8072V16.1248V17.4424H3.03978V18.7601V20.0777V21.3953H4.33789V22.7129V24.0424H5.636V25.36V26.6777H6.93412V27.9953H8.23223H9.53034V29.3129H10.8285V30.6305H12.1266H13.4247H14.7228H16.0209V31.9481H17.319V33.2658H18.6171V34.6071H19.9152H21.2133V33.2895H19.9152V31.9719H18.6171V30.6543H17.319V29.3366H16.0209V28.019V26.7014V25.3838V24.0424V22.7248V21.4072V20.0896V18.7719V17.4543V16.1367V14.8191V13.5015V12.172V10.8543V9.53673V8.21911V6.90149V5.58387V4.25438V2.93676H17.319V4.25438V5.572V6.88962V8.20724V9.52486V10.8425V12.172V13.4896V14.8072V16.1248V17.4424V18.7601V20.0777V21.3953V22.7129V24.0424V25.36V26.6777V27.9953V29.3129H18.6171V30.6305H19.9152V31.9481H21.2133V33.2658H22.5115V34.6071H23.8096V35.9247H22.5115V37.2424H23.8096H25.1077V38.56H26.4058H27.7039H29.002H30.3001V39.8776V41.1952V42.5128V43.8305V45.1481V46.4776V47.7952V49.1128V50.4304V51.748V53.0657V54.3833V55.7009V57.0185H29.002H27.7039H26.4058V58.348H25.1077H23.8096V59.6656H22.5115V60.9832H23.8096H25.1077H26.4058H27.7039H29.002H30.3001H31.5982H32.8963H34.1945H35.4926H36.7907H38.0888H39.3869H40.685H41.9831V59.6656H40.685H39.3869V58.348H38.0888H36.7907V57.0304H35.4926V55.7128V54.3952V53.0775V51.7599V50.4423V49.1247V47.8071V46.4776V45.1599V43.8423V42.5247V41.2071V39.8895H34.1945V38.5718H35.4926H36.7907V37.2542H38.0888H39.3869V35.9366H40.685V34.6071H41.9831H43.2812V33.2895H44.5794V31.9719H45.8775V30.6543H47.1756V29.3366H48.4737V28.019V26.7014V25.3838V24.0424V22.7248V21.4072V20.0896V18.7719V17.4543V16.1367V14.8191V13.5015V12.172V10.8543V9.53673V8.21911V6.90149V5.58387V4.25438H49.7718V2.93676H51.0699V1.61914H49.7718H48.4737H47.1756H45.8775H44.5794H43.2812H41.9831H40.685H39.3869H38.0888H36.7907H35.4926H34.1945H32.8963H31.5982H30.3001H29.002H27.7039H26.4058H25.1077H23.8096H22.5115H21.2133H19.9152H18.6171H17.319H16.0209H14.7228H13.4247V2.93676H12.1266H10.8285H9.53034H8.23223H6.93412H5.636H4.33789H3.03978H1.74167V4.25438V5.58387ZM4.33789 17.4543V16.1367V14.8191V13.5015V12.172V10.8543V9.53673V8.21911V6.90149V5.58387H5.636H6.93412H8.23223H9.53034H10.8285H12.1266H13.4247H14.7228V6.90149V8.21911V9.53673V10.8543V12.172V13.4896V14.8072V16.1248V17.4424V18.7601V20.0777V21.3953V22.7129V24.0424V25.36V26.6777V27.9953H13.4247H12.1266V26.6777H10.8285H9.53034V25.36H8.23223V24.0424H6.93412V22.7248V21.4072H5.636V20.0896V18.7719H4.33789V17.4543Z",
    fill: "#FECE00"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4412 60.9841H25.1431H23.8449H22.5468V59.6665H21.2487V60.9841V62.3018H22.5468H23.8449H25.0014H25.1431H26.4412H27.7393V60.9841H26.4412Z",
    fill: "#1F1F1F"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8449 58.3486H22.5468V59.6663H23.8449V58.3486Z",
    fill: "#1F1F1F"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8449 58.3494H25.143H26.4411V57.0317H25.143H25.0014H23.8449V58.3494Z",
    fill: "#1F1F1F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4458 38.5601H38.1477V39.8777H39.4458H40.744H42.0421V38.5601H40.744H39.4458Z",
    fill: "#1F1F1F"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0492 57.0305H30.3473V55.7129V54.3952V53.0657V51.7481V50.4305V49.1129V47.7953V46.4776V45.16V43.8424V42.5129V41.1953V39.8777V38.5601H29.0492H27.7393H26.4412H25.1431V39.8777H26.4412H27.7393H29.0492V41.1953V42.5129V43.8424V45.16V46.4776V47.7953V49.1129V50.4305V51.7481V53.0657V54.3952V55.7129H27.7393H26.4412V57.0305H27.7393H29.0492Z",
    fill: "#1F1F1F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3402 37.2432H42.0421V38.5608H43.3402V37.2432Z",
    fill: "#1F1F1F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8449 37.2432H22.5468V38.5608H23.8449H25.143V37.2432H23.8449Z",
    fill: "#1F1F1F"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3402 35.9253V37.2429H44.6383H45.9482V35.9253H44.6383H43.3402Z",
    fill: "#1F1F1F"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2487 35.9253H19.9388V37.2429H21.2487H22.5468V35.9253H21.2487Z",
    fill: "#1F1F1F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2463 34.6084H45.9482V35.926H47.2463V34.6084Z",
    fill: "#1F1F1F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9388 34.6084H18.6407V35.926H19.9388V34.6084Z",
    fill: "#1F1F1F"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5444 33.2769H47.2463V34.5945H48.5444V33.2769Z",
    fill: "#1F1F1F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6407 33.2769H17.3426V34.5945H18.6407V33.2769Z",
    fill: "#1F1F1F"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8426 31.9609H48.5445V33.2786H49.8426V31.9609Z",
    fill: "#1F1F1F"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0445 31.9609V33.2786H16.3395H17.3426V31.9609H16.0445Z",
    fill: "#1F1F1F"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4388 30.6421H51.1406H49.8425V31.9597H51.1406H52.4388H53.7487H55.0468V30.6421H53.7487H52.4388Z",
    fill: "#1F1F1F"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7464 30.6421H13.4483H12.1384H10.8402V31.9597H12.1384H13.4483H14.7464H16.0445V30.6421H14.7464Z",
    fill: "#1F1F1F"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3449 29.3267H55.0468V30.6443H56.3449V29.3267Z",
    fill: "#1F1F1F"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8402 29.3267H9.54208V30.6443H10.8402V29.3267Z",
    fill: "#1F1F1F"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3449 28.0068V29.3245H57.6431H58.9412V28.0068H57.6431H56.3449Z",
    fill: "#1F1F1F"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M8.244 28.0068H6.94589V29.3245H8.244H9.54212V28.0068H8.244Z",
    fill: "#1F1F1F"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2392 26.6899H58.9411V28.0076H60.2392V26.6899Z",
    fill: "#1F1F1F"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9412 5.5835H57.643H56.3449H55.0468H53.7487H52.4388H51.1407V6.90112V8.21873V9.53636V10.854V12.1716V13.4892V14.8068V16.1363V17.4539V18.7716V20.0892V21.4068V22.7244V24.042V25.3715V26.6892V28.0068H52.4388H53.7487V26.6892H52.4388V25.3715V24.042V22.7244V21.4068V20.0892V18.7716V17.4539V16.528V16.1363V14.8068V13.4892V12.1716V10.854V9.53636V8.21873V6.90112H53.7487H55.0468H56.3449H57.643H58.9412H60.2393V8.21873V9.53636V10.854V12.1716V13.4892V14.8068V16.1363V17.4539H61.5374V16.1363V14.8068V13.4892V12.1716V10.854V9.53636V8.21873V6.90112V5.5835H60.2393H58.9412Z",
    fill: "#1F1F1F"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64777 10.854V9.53636V8.21873V6.90112H6.94588H8.244H9.54211H10.8402H12.1383H13.4482V8.21873V9.53636V10.854V12.1716V13.4892V14.8068V16.1363V17.4539V18.7716V20.0892V21.4068V22.7244V24.042V25.3715V26.6892H12.1383V28.0068H13.4482H14.7464V26.6892V25.3715V24.042V22.7244V21.4068V20.0892V18.7716V17.4539V16.1363V14.8068V13.4892V12.1716V10.854V9.53636V8.21873V6.90112V5.5835H13.4482H12.1383H10.8402H9.54211H8.244H6.94588H5.64777H4.33786V6.90112V8.21873V9.53636V10.854V12.1716H5.64777V10.854Z",
    fill: "#1F1F1F"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94585 26.6899H5.64774V28.0076H6.94585V26.6899Z",
    fill: "#1F1F1F"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3449 26.6897V25.3721H55.0468H53.7487V26.6897H55.0468H56.3449Z",
    fill: "#1F1F1F"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1384 25.3721H10.8402V26.6897H12.1384V25.3721Z",
    fill: "#1F1F1F"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64777 24.0425H4.33786V25.372V26.6896H5.64777V25.372V24.0425Z",
    fill: "#1F1F1F"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2393 25.372V26.6896H61.5374V25.372V24.0425H60.2393V25.372Z",
    fill: "#1F1F1F"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54207 24.0425H8.24396V25.3601H9.54207V24.0425Z",
    fill: "#1F1F1F"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8355 22.7256H61.5374V24.0432H62.8355V22.7256Z",
    fill: "#1F1F1F"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6431 22.7256H57.0766H56.3449V24.0432V25.3727H57.6431V24.0432V22.7256Z",
    fill: "#1F1F1F"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33781 21.4062H3.0397V22.7239V24.0415H4.33781V22.7239V21.4062Z",
    fill: "#1F1F1F"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9411 21.4062H57.643V22.7239H58.9411V21.4062Z",
    fill: "#1F1F1F"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M8.244 21.4062H6.94589V22.7239V24.0415H8.244V22.7239V21.4062Z",
    fill: "#1F1F1F"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94585 18.7725H5.64774V20.0901V21.4077H6.94585V20.0901V18.7725Z",
    fill: "#1F1F1F"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2392 18.7717V17.4541H58.9411V18.7717V20.0894V21.407H60.2392V20.0894V18.7717Z",
    fill: "#1F1F1F"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64777 17.454V16.1364V14.8069V13.4893H4.33786V14.8069V16.1364V17.454V18.7716H5.64777V17.454Z",
    fill: "#1F1F1F"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1454 5.58412V6.90174V8.21936V9.53698V10.8546V12.1722V13.4898V14.8075V16.1369V17.4546V18.7722H62.8473V20.0898V21.4074V22.725H64.1454V21.4074V20.0898H65.4435V18.7722V17.4546V16.1369V14.8075V13.4898V12.1722V10.8546V9.53698V8.21936V6.90174V5.58412V4.25463V2.93701H64.1454V4.25463V5.58412Z",
    fill: "#1F1F1F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03974 21.4074V20.0898V18.7722V17.4546H1.74162V16.1369V14.8075V13.4898V12.1722V10.8546V9.53698V8.21936V6.90174V5.58412V4.25463V2.93701H0.443512V4.25463V5.58412V6.90174V8.21936V9.53698V10.8546V12.1722V13.4898V14.8075V16.1369V17.4546V18.7722H1.74162V20.0898V20.4697V21.4074H3.03974Z",
    fill: "#1F1F1F"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7487 2.93677H55.0468H56.3449H57.6431H58.9412H60.2393H61.5374H62.8473H64.1454V1.61914H62.8473H61.5374H60.2393H58.9412H57.6431H56.3449H55.0468H53.7487H52.4388V2.93677H53.7487Z",
    fill: "#1F1F1F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33789 2.93702H5.6478H6.94592H8.24403H9.54214H10.8403H12.1384H13.4483V1.61939H14.7464H16.0445H17.3426H18.6407H19.9388H21.2487H22.5469H23.845H25.1431H26.4412H27.7393H29.0492H30.3473H31.6454H32.9436H34.2417H35.5398H36.8379H38.1478H39.4459H40.744H42.0421H43.3402H44.6384H45.9483H47.2464H48.5445H49.8426H51.1407H52.4388V0.301758H51.1407H49.8426H48.5445H47.2464H45.9483H44.6384H43.3402H42.0421H40.744H39.4459H38.1478H36.8379H35.5398H34.2417H32.9436H31.6454H30.3473H29.0492H27.7393H26.4412H25.1431H23.845H22.5469H21.2487H19.9388H18.6407H17.3426H16.0445H14.7464H13.4483H12.1384V1.61939H10.8403H9.54214H8.24403H6.94592H5.6478H4.33789H3.03978H1.74167V2.93702H3.03978H4.33789Z",
    fill: "#1F1F1F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.ff735f24adebd33e232448549b024e9f.svg";
export { ForwardRef as ReactComponent };